import * as _ from 'underscore'

export class WhereClauseHelper {


    public static appendEquals(whereClause: string, key: string, value: number): string {
        if (this.isKeyValid(key)) {
            if (this.isCustomWhereClauseEmpty(whereClause)) {
                return '( [' + key + '] = ' + value + ' )'
            }

            return whereClause + ' AND ( [' + key + '] = ' + value + ' )'
        }
    }

    //#region In

    public static appendIn(whereClause: string, key: string, value: string | number, negate: boolean = false): string {
        if (_.isNumber(value)) {
            value = value.toString()
        }
        if (this.isKeyValid(key)) {
            const operator: string = negate ? ' NOT IN ' : ' IN '

            if (this.isCustomWhereClauseEmpty(whereClause)) {
                return '[' + key + ']' + operator + '(' + value + ')'
            }

            return whereClause + ' AND ( [' + key + ']' + operator + '(' + value + ') )'
        }
    }

    //#endregion


    private static isKeyValid(key: string): boolean {
        return key != null && key.length > 0
    }

    private static isCustomWhereClauseEmpty(whereClause: string): boolean {
        return whereClause == null || whereClause.length === 0
    }
}
